import React, { useEffect, useState } from 'react';
import { getNavigationLinks } from '../data';
import { NavigationLink } from '../types/NavigationLink';
import { useTranslations } from '../../localization/useTranslations';

const NavigationLinks = () => {
  const translations = useTranslations();
  const navigationLinks: NavigationLink[] = getNavigationLinks(translations);
  const [hash, setHash] = useState(window.location.hash);
  const myAccountSlug = window.myAccountPageSlug || 'my-account';

  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup function to remove the event listener when the component unmounts
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const renderListItem = (menuItem: NavigationLink) => {
    const menuItemHash = menuItem.href.replace(myAccountSlug, '');
    const activeClass = hash === menuItemHash ? 'account-dropdown__menu-item--active' : '';

    return (
      <li key={menuItem.href} className={`account-dropdown__menu-item icon-${menuItem.icon} ${activeClass}`}>
        <a href={menuItem.href} className={`account-dropdown__menu-link ${menuItem.class} link-16`}>
          {menuItem.name}
        </a>
      </li>
    );
  };

  const renderListItems = (links: NavigationLink[]) => {
    return links.map((link) => renderListItem(link));
  };

  const renderMenuItems = () => {
    let withIcons = navigationLinks.filter((link) => link.icon);
    const withoutIcons = navigationLinks.filter((link) => !link.icon);

    // Skip newsletter tab if windows.country is 'hu', find by class 'menu-link--my-newsletters'
    if (window.country === 'hu') {
      withIcons = withIcons.filter((link) => link.class !== 'menu-link--my-newsletters');
    }

    return (
      <>
        <ul className="account-dropdown__menu account-dropdown__menu--icon">{renderListItems(withIcons)}</ul>
        <ul className="account-dropdown__menu account-dropdown__menu--no-icons">{renderListItems(withoutIcons)}</ul>
      </>
    );
  };

  return <div className="account-dropdown__menu-wrapper">{renderMenuItems()} </div>;
};

export default NavigationLinks;
